import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router";
import qs from "web/core/utils/queryString";

const RedirectToPageOne = ({ location }) => {
  const queryParameters = {
    ...qs.parse(location.search),
    page: 1,
  };
  const pageOneUrl = `${location.pathname}?${qs.stringify(queryParameters)}`;
  return <Redirect to={pageOneUrl} />;
};

RedirectToPageOne.propTypes = {
  location: PropTypes.object.isRequired,
};

export default RedirectToPageOne;
